/**
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {TEMPLATE_REF_DIRECTIVES} from './index';
export class ClrTemplateRefModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [TEMPLATE_REF_DIRECTIVES],
    entryComponents: [TEMPLATE_REF_DIRECTIVES],
    exports: [TEMPLATE_REF_DIRECTIVES]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrTemplateRefModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrTemplateRefModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrTemplateRefModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
